module.exports = __webpack_public_path__ + "img/notify.6b557923.png";